/* eslint-disable react/jsx-props-no-spreading */

"use client";

import { PriceSummaryDetails } from "@/components/molecules/renewals/payment-summary/price-summary/price-summary-details/price-summary-details";
import { PriceSummaryHeader } from "@/components/molecules/renewals/payment-summary/price-summary/price-summary-header/price-summary-header";
import { PriceSummaryInfo } from "@/components/molecules/renewals/payment-summary/price-summary/price-summary-info/price-summary-info";
import { PriceSummarySectionSchemaType } from "@/schema/renewal-page/payment-summary-page.schema";

type PriceSummarySectionProps = {
  content: PriceSummarySectionSchemaType;
  gotAPromoOrVoucherCode?: () => void;
};

export function PriceSummarySection({
  content,
  gotAPromoOrVoucherCode,
}: Readonly<PriceSummarySectionProps>) {
  return (
    <div className="flex flex-col md:p-spacing-xxl p-spacing-l pt-0 gap-spacing-xl">
      <PriceSummaryHeader {...content.priceSummaryHeader} />

      <PriceSummaryDetails
        content={content}
        gotAPromoOrVoucherCode={gotAPromoOrVoucherCode}
      />

      <PriceSummaryInfo {...content.agreementContent} />
    </div>
  );
}
